import { connectionStatusClasses } from "../common/tailwindClassnames";

export const getConnectionStatus = (status: string, details_page: boolean, t: (key: string) => string) => {
    switch (status) {
        case "healthy":
            return { text: t("Healthy"), style: connectionStatusClasses.healthy(details_page) };
        case "unhealthy":
            return { text: t("Unhealthy"), style: connectionStatusClasses.unhealthy(details_page) };
        case "needs_review":
            return { text: t("Needs Review"), style: connectionStatusClasses.needsReview(details_page) };
        case "disabled":
            return { text: t("Disabled"), style: connectionStatusClasses.disabled(details_page) };
        default:
            return { text: t("Unknown"), style: connectionStatusClasses.unknown(details_page) };
    }
};